/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDistributionPluginSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetDistributionPluginRequest = {
  skillId: string;
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetDistributionPluginSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDistributionPluginSecurity$outboundSchema: z.ZodMiniType<
  GetDistributionPluginSecurity$Outbound,
  GetDistributionPluginSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getDistributionPluginSecurityToJSON(
  getDistributionPluginSecurity: GetDistributionPluginSecurity,
): string {
  return JSON.stringify(
    GetDistributionPluginSecurity$outboundSchema.parse(
      getDistributionPluginSecurity,
    ),
  );
}

/** @internal */
export type GetDistributionPluginRequest$Outbound = {
  skill_id: string;
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetDistributionPluginRequest$outboundSchema: z.ZodMiniType<
  GetDistributionPluginRequest$Outbound,
  GetDistributionPluginRequest
> = z.pipe(
  z.object({
    skillId: z.string(),
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      skillId: "skill_id",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getDistributionPluginRequestToJSON(
  getDistributionPluginRequest: GetDistributionPluginRequest,
): string {
  return JSON.stringify(
    GetDistributionPluginRequest$outboundSchema.parse(
      getDistributionPluginRequest,
    ),
  );
}
